module.exports = __webpack_public_path__ + "assets/envelope.e14b0274.svg";